<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <b-modal
      v-model="localModalVisorImg"
      no-close-on-backdrop
      hide-header-close
      hide-header
      centered
      size="xl"
  >
    <b-row>
      <b-col cols="12">
        <em class="img_svg primary sm"></em>
        <span v-if="archivo !== undefined &&
                    archivo !== null" style="color: var(--color-dentalia-1-v2); font-weight: bold;"> {{archivo.Name}}</span>
        <div v-if="esImagen">
          <VisorImagenesECE :listaImagenes="listaVisor" :index.sync="indexImagen"/>
        </div>
        <div v-else>
          <iframe
              class="archivo-frame"
              v-if="archivo !== undefined &&
                    archivo !== null && archivo.extension === 'pdf' && archivo.Length <= 1000000"
              :src="'data:application/pdf;base64,' + archivo.imagenBase64"
          />

          <div
              v-if="
                archivo !== undefined && archivo !== null && archivo.extension === 'pdf' &&
                archivo.Length > 1000000
              "
          >
            <div
                id="pdf-fame"
            >
              <pdf
                  v-for="i in numPages"
                  :key="i"
                  :page="i"
                  :src="'data:application/pdf;base64,' + archivo.imagenBase64"
                  @page-loaded="renderizarPaginas($event)"
                  style="
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    border: 3px solid #b4b4b4;
                  "
              ></pdf>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div slot="modal-footer">
      <b-button variant="outline-danger" @click="cerrarModal()"
      >Cerrar</b-button
      >
    </div>
  </b-modal>
</div>
</template>


<script>
import pdf from "vue-pdf";
import VisorImagenesECE from "@/components/VisorImagenesECE/VisorImagenesECE.vue";

export default {
  name: "VistaPreviaHerramienta",
  props: {
    modalVisor: Boolean,
    archivo:Object,
    listaVisor: Array
  },
  components: {
    VisorImagenesECE,
    pdf,
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      numPages: 0,
      numPageCargada: 0.5,
      indexImagen: 0,
      localModalVisorImg: false
    };
  },
  watch: {
    modalVisor(newVal) {
      this.localModalVisorImg = newVal;
      console.log(newVal)
    },
    archivo(newVal) {
      if(newVal.extension === 'pdf' && newVal.Length > 1000000){
        this.numPages = 0;
        this.numPageCargada = 1;
        let pdfDocument = pdf.createLoadingTask(
            "data:application/pdf;base64," + newVal.imagenBase64
        );
        pdfDocument.promise.then((pdf) => {
          this.numPages = pdf.numPages;
        });
      }
    }
  },
  computed: {
    esImagen() {
      let exprecionRegular = /\.(png|jpe?g)$/i;
      if (this.archivo != null && exprecionRegular.test(this.archivo.Name)) {
        this.listaVisor.forEach((value,i) => {
          if(value.Name === this.archivo.Name){
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.indexImagen  = i;
          }
        })
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    renderizarPaginas($event) {
      this.numPageCargada = $event;
      if (
          this.numPageCargada !== undefined &&
          this.numPageCargada !== null &&
          this.numPageCargada > 0
      ) {
        if (this.numPages === $event) {
          //this.blnLoaderModal = false;
        }
      }
    },
    cerrarModal() {
      this.localModalVisorImg = false;
      this.modalVisor = false;
      this.$emit('modalVisor', false);
    },
  }
}
</script>

<style scoped>
.archivo-frame {
  width: 100% !important;
  height: 77vh !important;
}
</style>

